import React, { useState } from "react";
import Input from "/components/core/labels/Input";
import Checkbox from "/components/core/labels/Checkbox";
import Hidden from "/components/core/labels/Hidden";
import CustomButton from "/components/core/ButtonDefault";
import { useTranslation } from "react-i18next";
import { useDetectLanguage } from "../wallet-auth/hooks/useDetectLanguage";
import { useGetReferral } from "../wallet-auth/hooks/useGetReferral";
import { useValidateNickname } from "../wallet-auth/hooks/useValidateNickname";
import { ssoLabels } from "./SocialButtonsGrid";
import Select from "/components/core/labels/Select";
import { useCountries } from "/api/user/countries";

const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,15}$/;

export function SSOAdditionalForm({
  handleSubmit,
  isMutating,
  selectedProvider,
}) {
  const { t } = useTranslation();
  const { detectedLanguage } = useDetectLanguage();
  const { btag } = useGetReferral();
  const [formData, setFormData] = useState({
    name: "",
    consent: false,
    country: "",
  });
  const { isNameOk, nameErrors } = useValidateNickname(formData.name);
  const showForm = ssoLabels.find((s) => s.name === selectedProvider);
  const { data: countries } = useCountries();

  const isSubmitDisabled =
    !USERNAME_REGEX.test(formData.name) ||
    !formData.country ||
    !isNameOk ||
    !formData.consent ||
    isMutating;

  const onSubmit = async (e) => {
    e.preventDefault();

    const formValues = Object.entries(
      Object.fromEntries(new FormData(e.target))
    ).reduce((acc, [key, value]) => {
      if (key === "consent") {
        return acc;
      }

      return { ...acc, [key]: value === "on" ? true : value };
    }, {});

    await handleSubmit(formValues);
  };

  if (!showForm) {
    return null;
  }

  return (
    <form onSubmit={onSubmit} className="form df fd-c">
      <div className="form_content">
        {detectedLanguage && (
          <Hidden name="language_id" value={detectedLanguage.uuid} />
        )}
        {btag && <Hidden name="btag" value={btag} />}
        <Hidden name="page" value="gaming" />
        <Hidden type="checkbox" name="older" checked={formData.consent} />
        <Hidden type="checkbox" name="agree" checked={formData.consent} />
        <Hidden
          type="checkbox"
          name="is_marketing_communication_allowed"
          checked={formData.consent}
        />

        <Input
          type="text"
          name="name"
          value={formData.name}
          handleChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              name: e.target.value,
            }))
          }
          placeholder={t("registration.labels.username.placeholder")}
          description={t("registration.labels.username.description")}
          autoComplete="off"
          tip={{
            title: t("registration.labels.username.placeholder"),
            tip: t("registration.labels.username.tip"),
          }}
          error={
            !USERNAME_REGEX.test(formData.name) && formData.name
              ? t("registration.errors.usernameLength")
              : nameErrors
          }
          isOk={USERNAME_REGEX.test(formData.name) && isNameOk}
          callback={undefined}
          label={undefined}
          limited={false}
          spaces={false}
        >
          {null}
        </Input>

        <Select
          handleChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              country: e.target.value,
            }))
          }
          list={countries}
          placeholder={t("registration.labels.country.placeholder")}
          name="country"
          search={true}
          value={formData.country}
          label={undefined}
          error={undefined}
          def={undefined}
          tip={{
            title: t("registration.labels.country.title"),
          }}
        />

        <Checkbox
          type="checkbox"
          title={t("registration.labels.consent.title")}
          name="consent"
          value={formData.consent}
          required
          handleChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              consent: e.target.checked,
            }))
          }
          checked={formData.consent}
          def={undefined}
          underline={undefined}
          dot={undefined}
        />
      </div>

      <div className="buttons df mr-t-46">
        <CustomButton
          classname="submit pr as-c"
          def={40}
          type="submit"
          disabled={isSubmitDisabled}
          title={
            isMutating
              ? t("labels.registering")
              : `${t("labels.registerWith")} ${showForm.label}`
          }
          onClick={() => {}}
        />
      </div>
    </form>
  );
}
